




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
declare var window: any;

@Component
export default class SsoLogin extends Vue {
  @Prop({ default: () => {} }) facebookLogin;
  @Prop({ default: () => {} }) googleLogin;
  @Prop({ default: () => {} }) loginWithApple;
  @Prop({ default: () => {} }) linkedinLogin;
  @Prop({ default: '' }) header;

  get enabledAppleSignup() {
    return false
  }

  get socialRegistrationConfigs() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      return vxm.configs.SocialLoginConfig
    }
    return vxm.jobs.BrandingInfo.SOCIAL_REGISTRATION;
  }
  get enableSocialRegistration() {
    if (
      this.socialRegistrationConfigs.ENABLE_FACEBOOK_REGISTRATION ||
      this.socialRegistrationConfigs.ENABLE_GOOGLE_REGISTRATION ||
      this.socialRegistrationConfigs.ENABLE_LINKDEIN_REGISTRATION
    ) {
      return true;
    }
    return false;
  }
}
